export default __webpack_public_path__ + "static/media/cont_item_07.6e877d9f.svg";